import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import OCDSApiService from '../service/OCDSApiService';


export const OCDSReleasePackage = () => {


    const [packages, setPackages] = useState(null);
    const [globalFilter3, setGlobalFilter3] = useState('');
    const [loading1, setLoading1] = useState(true);



    useEffect(() => {
        const oCDSApiService = new OCDSApiService();
        oCDSApiService.getReleasePackageItemList().then(data => { setPackages(data); setLoading1(false) });
    }, []);

    

    const formatDate = (value) => {
        return new Intl.DateTimeFormat('en-GB', {
            month: 'long',
            day: '2-digit',
            year: 'numeric',
        }).format(new Date(value))
    };


    const bodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]}
            </>
        );
    };

    
    const actionTemplate = (data, props) => {
        return (
            <>
                <Button type="button" icon="pi pi-download" className="p-button-warning" onClick={handleDownloadReleasePackage(data[props.field])}></Button>
            </>
        )
    };

    const handleDownloadReleasePackage = (params) => (e) => {
        e.preventDefault();
        //alert(params);
        const year = params.substring(0, 4);
        const month = params.substring(4, 6);
        const oCDSApiService = new OCDSApiService();
        oCDSApiService.getReleasePackageItem(year, month).then(data => console.log(data));
    }

    const actionTemplate2 = (data, props) => {
        return (
            <>
                <Button type="button" icon="pi pi-download" className="p-button-info" onClick={handleDownloadRecordPackage(data[props.field])}></Button>
            </>
        )
    };

    const handleDownloadRecordPackage = (params) => (e) => {
        e.preventDefault();
        //alert(params);
        const year = params.substring(0, 4);
        const month = params.substring(4, 6);
        const oCDSApiService = new OCDSApiService();
        oCDSApiService.getRecordPackageItem(year, month).then(data => console.log(data));
    }

    

    const actionTemplate3 = (data, props) => {
        return (
            <>
                <Button type="button" icon="pi pi-download" className="p-button-success" onClick={handleDownloadExcelExport(data[props.field])}></Button>
            </>
        )
    };

    const handleDownloadExcelExport = (params) => (e) => {
        e.preventDefault();
        //alert(params);
        const oCDSApiService = new OCDSApiService();
        oCDSApiService.getExcelExportPackageItem(params).then(data => console.log(data));
        //var url = 'https://ocdsapi.dppib-crsgov.org/api/ocdsAPI/getExcelPackageFile?id=' + params ;

        //window.open(url, '_blank');
    }

   
    const contractDateBodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">Price</span>
                {formatDate(data[props.field])}
            </>
        );
    };

   
    const customer2TableHeader = (
        <div className="table-header">
            List of Packages
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilter3} onChange={(e) => setGlobalFilter3(e.target.value)} placeholder="Global Search" />
            </span>
        </div>
    );

    return (
        <div className="p-grid table-demo">
            
            <div className="p-col-12">
                <div className="card">
                    
                    <DataTable value={packages} scrollable scrollHeight="600px" className="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-customers"
                        dataKey="id" rowHover globalFilter={globalFilter3} emptyMessage="No packages found." loading={loading1} header={customer2TableHeader}>
                        <Column field="monthname" header="Month Name" sortable body={bodyTemplate}></Column>
                        <Column field="year" header="Year" sortable body={bodyTemplate}></Column>
                        <Column field="totalnumberofreleases" header="Total No. of Releases" sortable body={bodyTemplate}></Column>
                        <Column field="date_created" header="Date Created" sortable body={contractDateBodyTemplate}></Column>
                        <Column field="date_modified" header="Date Modified" sortable body={contractDateBodyTemplate}></Column>
                        <Column field="id" header="JSON Release Package" headerStyle={{ width: '5rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible', justifyContent: 'center' }} body={actionTemplate}></Column>
                        <Column field="id" header="JSON Record Package" headerStyle={{ width: '5rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible', justifyContent: 'center' }} body={actionTemplate2}></Column>
                        <Column field="id" header="Excel Export" headerStyle={{ width: '5rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible', justifyContent: 'center' }} body={actionTemplate3}></Column>
                    </DataTable>
                </div>
            </div>

        </div>
    )
}
